import React from 'react';
import { Route,Switch } from 'react-router';

import Home from '../Pages/Home';
import Products from '../Pages/Products';
import Sale from '../Pages/Sale';
import About from '../Pages/About';
import Support from '../Pages/Support';
import Checkout from '../Pages/Checkout';
import PlaceOrder from '../Pages/PlaceOrder';
import Sucessfulpurchase from '../Pages/Sucessfulpurchase';

import Signup from '../Pages/Signup';
import Login from '../Pages/Login';
import Logout from '../Pages/Logout';

import Error from '../Pages/Error';

const Routing = () => {
    return (
        <>
            <Switch>
                <Route exact path="/">
                    <Home/>
                </Route>
                <Route exact path="/products">
                    <Products/>
                </Route>
                <Route exact path="/sales">
                    <Sale/>
                </Route>
                <Route exact path="/about">
                    <About/>
                </Route>
                <Route exact path="/support">
                    <Support/>
                </Route>
                <Route exact path="/checkout">
                    <Checkout/>
                </Route>
                <Route exact path="/placeorder">
                    <PlaceOrder/>
                </Route>
                <Route exact path="/Sucessfully-placed">
                    <Sucessfulpurchase/>
                </Route>
                <Route exact path="/signup">
                    <Signup/>
                </Route>
                <Route exact path="/login">
                    <Login/>
                </Route>
                <Route exact path="/signout">
                    <Logout/>
                </Route>
                <Route>
                    <Error/>
                </Route>
            </Switch>
        </>
    )
}

export default Routing;
